const goTo = (dom) => {
    if (dom) {
        // Determine the position where to scroll
        // * 60 is header height 
        // * 12 is var(--space-medium) value, the space between boxes
        let top = dom.getBoundingClientRect().y + (document.documentElement.scrollTop || document.body.scrollTop) - 60 - 12;
        if (top < 0) {
            top = 0;
        }
        window.scrollTo({
            top,
            behavior: 'smooth'
        });
        return true;
    }
    return false;
}

const getSelector = (selector) => selector ? typeof (selector) === 'function' ? selector() : selector : null;

export const scrollToElement = ((selector, forceDuration = null) => {
    setTimeout(() => {
        const interval = forceDuration !== null ? setInterval(() => {
            if (goTo(getSelector(selector))) {
                clearInterval(interval);
            }
        }, 50) : null;

        const timeout = forceDuration !== null ? setTimeout(() => {
            clearInterval(interval);
        }, forceDuration) : null;

        if (goTo(getSelector(selector))) {
            clearInterval(interval);
            clearTimeout(timeout);
        }
    }, 500);
});
